import moment, { Moment } from 'moment';
import JSEncrypt from 'jsencrypt';
import { Key } from 'react';
type Clone<T> = {
    [K in keyof T]: T[K];
};

export const deepClone = <T extends object = any>(target: Clone<T>):T => {
    // 定义一个变量
    let result: any = {};
    // 如果当前需要深拷贝的是一个对象的话

    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i] as any);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
};

export const fullScreen = ():void => {
    const element: any = document.documentElement;

    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
};

export const exitFullscreen = ():void => {
    const doc: any = document;

    if (doc.exitFullscreen) {
        doc.exitFullscreen();
    } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
    }
};

export const randomStr = (num: number = 32): string => {
    const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789';
    let unid = '';

    for (let i = 0; i < num; i++) {
        unid += str.charAt(Math.floor(Math.random() * str.length));
    }
    return unid;
};

export const dateFormat = (str = 'YYYY MM DD h:mm:ss', data: Date|Moment = new Date()): any => moment(data).format(str);

export const jsonIntersection = (arr: any[], list: any[], key: any) => arr.filter((v) => list.some((n) => {
    if (typeof v[key] !== undefined && typeof n[key] !== undefined) {
        return v[key] === n[key];
    }
}));

// 计算分页
export const arrPaging = (data: any[], page: number, pageSize: number) => data.slice((page - 1) * pageSize, pageSize * page);

export const IsEmptyObejct = (obj: Object = {}) => {
    const arr = Object.keys(obj);

    return arr.length;
};

// 判断是否为IP
export const IsIp = (value:string) => {
    const regexp = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;

    return regexp.test(value);
};

import { useCallback, useEffect, useRef } from 'react';
type Debounce = {
    fn: Function;
    timer: null | any;
}

/**
 * 防抖
 * @param fn 函数
 * @param delay 时间
 * @param dep 监控对象
 * @returns 返回一个防抖函数
 */

export const useDebounce = (fn:Function, delay:number, dep = []) => {
    const { current } = useRef<Debounce>({ fn, timer: null });

    useEffect(function () {
        current.fn = fn;
    }, [ fn ]);

    return useCallback(function f (...args) {
        if (current.timer) {
            clearTimeout(current.timer);
        }
        current.timer = setTimeout(() => {
            current.fn.call(this, ...args);
        }, delay);
    }, dep);
};

export const useThrottle = (fn:Function, delay:number, dep = []) => {
    const { current } = useRef<Debounce>({ fn, timer: null });

    useEffect(function () {
        current.fn = fn;
    }, [ fn ]);

    return useCallback(function f (...args) {
        if (!current.timer) {
            current.timer = setTimeout(() => {
                delete current.timer;
            }, delay);
            current.fn.call(this, ...args);
        }
    }, dep);
};

// 数组转换 flag为true是删除，flase是余数
export const arrFormat = <T>(arr: T[], list: Key[], key: keyof T, flag: boolean = true) => arr.filter((v) => {
    if (!flag) {
        return list.some((i) => v[key] === i);
    } else {
        return list.every((i) => v[key] !== i);
    }
});

type WebSocketStatus = {
    status: string;
    cardtypeno: string;
    params: string;
}

export const interceptWebSocketMessage = (message:string):WebSocketStatus|undefined => {
    // WebSocket 返回格式：FFFF 001 000025 S061=12345678@X00018=2019 F0
    // 包头(4位)：FFFF
    // 返回值状态（3位）：000：正确；其他值：失败,001=-1，002=-2，...
    // 数据长度（6位）：000025
    // 返回参数及参数值 S061=12345678@X00018=2019  FFFF009000006X00123F0
    // 包尾（2位）：F0

    if (message) {
        let length = message.length;
        // 获取状态码
        let status = message.substr(4, 3);
        // 卡类型
        let cardtypeno = message.substr(7, 4);
        // 获取参数字符串
        let params = message.substr(17, length - 19);

        let datas = { 'status': status, 'cardtypeno': cardtypeno, 'params': params };

        return datas;
    } else {
        return undefined;
    }
};

export const webSocketErrorCode = (strValue:string) => {
    let strReturn = '';

    switch (strValue) {
        case '001':
            strReturn = 'Error Message Code -1:[Error No.]';
            break;
        case '002':
            strReturn = 'Error Message Code -2:[Error Holiday.]';
            break;
        case '003':
            strReturn = 'Error Message Code -3:[Error Init Card Machine.]';
            break;
        case '004':
            strReturn = 'Error Message Code -4:[Error Send Cmd.]';
            break;
        case '005':
            strReturn = 'Error Message Code -5:[Error User Card Type.]';
            break;
        case '006':
            strReturn = 'Error Message Code -6:[Error Write Mac.]';
            break;
        case '007':
            strReturn = 'Error Message Code -7:[Error Write Dack.]';
            break;
        case '008':
            strReturn = 'Error Message Code -8:[Error Meter Num Too Big.]';
            break;
        case '009':
            strReturn = 'Error Message Code -9:[Error Exception.]';
            break;
        case '010':
            strReturn = 'Error Message Code -10:[Error Meter No Mismatch.]';
            break;
        case '011':
            strReturn = 'Error Message Code -11:[Error Custom No Mismatch]';
            break;

        case '033':
            strReturn = 'Error Message Code -13:[Error Card Type Unsupport.]';
            break;
        case '131':
            strReturn = 'Error Message Code -131:[Error New Card.]';
            break;
        case '137':
            strReturn = 'Error Message Code -137:[Error No Insert Meter.]';
            break;
        case '139':
            strReturn = 'Error Message Code -139:[Error Card Type.]';
            break;

        default:
            strReturn = '9999';
    }
    return strReturn;
};

// 校验经度是否符合规范
// 校验经度
export const checkLong = (lng: string): boolean => {
    if (!lng) {
        return false;
    }
    let longrg = /^-?((0|[1-9]\d{0,1})(\.\d{1,15})?|1[0-7]\d(\.\d{1,15})?|180(\.0+)?)$/;

    if (!longrg.test(lng)) {
        return false;
    }
    return true;
};

// 校验纬度是否符合规范
// 纬度
export const checkLat = (lat: string): boolean => {
    if (!lat) {
        return false;
    }
    let latreg = /^-?((0|[1-8]?\d{0,1}(\.\d{1,15})?)|90(\.0+)?)$/;

    if (!latreg.test(lat)) {
        return false;
    }
    return true;
};

export const assemblingWriteCardMessage = (msg:string) => {

    // 发送格式：FEFE 000 00255S061=12345678@X00018=2019F0
    // 包头(4位)：FEFE
    // DLL函数（3位）：000：readCard；001：writeCard；002：recycleCard
    // 数据长度（6位）：000025
    // 包尾（1位）：F0

    let length = msg.length;
    let writeCardMessage = 'FEFE001' + ('000000' + length).substr(-6) + msg + 'F0';

    return writeCardMessage;
};
let arrCode:string[] = [];
let arrValue:string[] = [];

export const splitdata = (str:string) => {

    let arr = [];
    let arrstr = [];
    let strtmp = '';

    // 去掉第一个字符@

    strtmp = str.substr(1, str.length - 1);


    // 得到代号=值为元素的数组
    arr = strtmp.split('@');

    for (let i = 0;i < arr.length - 1;i++) {
        arrstr = arr[i].split('=');
        arrCode[i] = arrstr[0];
        arrValue[i] = arrstr[1];
    }

};

export const getItemValueOfcode = (param:string) => {

    let arrtmp = [];
    let Sparam = param;

    arrtmp = Sparam.split('#');

    let paramcode = arrtmp[1];

    // 分解数据
    splitdata(arrtmp[0]);

    for (let i = 0; i < arrCode.length;i++) {

        if (arrCode[i] === paramcode) {
            return arrValue[i];
        }


    }
};

export const findparamvalue = (code:string) => {
    let code645 = code;

    return getItemValueOfcode('#' + code645 + '#');
} ;

export const getBeforeMonths = (i: number):string[] => {
    const arr = [];
    const newDate = new Date();
    const newMonth = newDate.getMonth() + 1;
    let o = 0;

    if (newMonth > i) {
        arr.push(`${newDate.getFullYear()}`);
        o = newMonth - i;
        arr.push(o >= 10 ? `${o}` : '0' + o);
    } else {
        arr.push(`${newDate.getFullYear() - 1}`);
        o = newMonth + 12 - i;
        arr.push(o >= 10 ? `${o}` : '0' + o);
    }
    return arr;
};

export const getBeforeMonthList = (n: number): string[] => {
    const arr = [];

    for (let i = 0; i < n; i++) {
        const str = getBeforeMonths(i).join('-');

        arr.unshift(str);
    }
    return arr;
};

// 判断是不是
export const isUndefined = (res:any):boolean => {
    if (typeof res !== 'undefined') {
        return true;
    }
    return false;
};

// pvms打印清单
export const getPrintTableContent = (isSingle: boolean, table: HTMLElement, align: string, content: string, title?: string) => {
    if (isSingle) {
        let tr1 = document.createElement('tr');
        let td1 = document.createElement('td');

        tr1.setAttribute('align', align);
        td1.setAttribute('colspan', '6');
        // td1.setAttribute('padding', '10');
        td1.innerText = content;
        tr1.appendChild(td1);
        table.appendChild(tr1);
    } else {
        let tr2 = document.createElement('tr');
        let td21 = document.createElement('td');
        let td22 = document.createElement('td');

        tr2.setAttribute('align', align);
        td21.setAttribute('colspan', '3');
        // td21.setAttribute('padding', '10');
        td22.setAttribute('colspan', '3');
        // td22.setAttribute('padding', '10px');
        td21.innerText = `${title}:`;
        td22.innerText = content;
        tr2.appendChild(td21);
        tr2.appendChild(td22);
        table.appendChild(tr2);
    }
};

export const isNumber = (val:string):boolean => {
    let regPos = /^\d+(\.\d+)?$/; // 非负浮点数
    let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数

    if (regPos.test(val) || regNeg.test(val)) {
        return true;
    }
    return false;
};

export const columnsFilter = <T, K extends keyof T> (columns: T[], key: K, keyVal: any): T[] => columns.filter((v) => v[key] !== keyVal);

export const isNoDefine = (row: any): boolean => {
    if (typeof row === 'undefined' || row === 'undefined' || row === null || row === 'null' || row === 'NULL') {
        return false;
    }
    return true;
};

export const jasperPirnt = (url:string, parameters:Object, features?:string) => {
    // 创建一个临时的form表单
    let tempForm = document.createElement('form');

    tempForm.id = 'jasperForm';
    tempForm.method = 'post';
    tempForm.action = url;
    // tempForm.enctype = 'multipart/form-data';

    // 新窗口
    if (features === undefined) {
        tempForm.target = '_blank';
    } else if (features === '') {
        features = 'width=' + (window.screen.availWidth - 10) + ',height=' + (window.screen.availHeight - 60) + ',top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no';
        window.open('', 'jasperTarget', features);
        tempForm.target = 'jasperTarget';
    } else {
        window.open('', 'jasperTarget', features);
        tempForm.target = 'jasperTarget';
    }

    // 创建input设置参数
    for (let param in parameters) {
        let hideInput = document.createElement('input');

        hideInput.type = 'hidden';
        hideInput.name = param;
        hideInput.value = parameters[param];
        tempForm.appendChild(hideInput);
    }
    // 将此form表单添加到页面主体body中
    document.body.appendChild(tempForm);
    // 手动触发，提交表单
    tempForm.submit();
    // 从body中移除form表单
    document.body.removeChild(tempForm);
};

// 按指定长度分段字符串
export const fixedLengthFormatString = (str:string, num:number) => {
    if (str === null || str === undefined) {return null;}
    if (!(/^[0-9]*[1-9][0-9]*$/.test(num + ''))) {return null;}
    let array = [];
    let len = str.length;

    for (let i = 0; i < (len / num); i++) {
        if ((i + 1) * num > len) {
            array.push(str.substring(i * num, len));
        } else {
            array.push(str.substring(i * num, (i + 1) * num));
        }
    }
    return array;
};

export const formatValue = <T>(val:T, defaultVal:T):T => {
    if (typeof val === 'undefined') {
        return defaultVal;
    }
    return val;
};

export const hextobin = (value:string) => {
    let strValue = parseInt(value, 16).toString(2);
    let arr = '0000';

    if (strValue.length < 4) {
        strValue = arr.substring(0, 4 - strValue.length) + strValue;
    }
    return strValue;
};

export const isCheckField = <T> (val: T, type: string) => {
    if (typeof val === type) {
        return val;
    }
    return '';
};

import { RouterConfig } from 'src/router/types';
export const findActiveRoute = (path: string, routers: RouterConfig[], openKeys:string[], parentKey?: string) => {
    routers.forEach((v) => {
        if (v.key && v.subs?.length) {
            findActiveRoute(path, v.subs, openKeys, v.key);
        }
        if (v.key === path) {
            if (parentKey) {
                openKeys.push(parentKey);
            }
            openKeys.push(v.key);
        }
    });
};

export const strReplace = (str: string, to: string, from: string): string => str.replace(to, from);

export const arrayExtendsAt = () => {
    if (!Array.prototype.at) {
        // eslint-disable-next-line no-extend-native
        Object.defineProperties(Array.prototype, {
            at: {
                writable: false,
                configurable: false,
                enumerable: false,
                value: function (index:number) {
                    // 处理负数索引
                    index = index >= 0 ? index : this.length + index;

                    // 检查索引是否越界
                    if (index < 0 || index >= this.length) {
                        return undefined;
                    }

                    return this[index];
                },
            },
        });
    }
};

export const numRate = (num: number, len: number = 2): string => {
    try {
        let rate = num;

        rate = isNaN(rate) ? 0 : rate;
        rate = isFinite(rate) ? rate : 0;
        rate = rate > 1 ? 1 : rate;
        return (rate * 100).toFixed(len);
    } catch (error) {
        return '0';
    }
};

export const filterEmptyStr = (obj:Object): Object => {
    const newObj = {};

    for (const v in obj) {
        if (typeof obj[v] !== 'undefined') {
            newObj[v] = obj[v];
        }
    }
    return newObj;
};

export const isValidDateTimeString = (dateTimeString:string) => {
    // 使用正则表达式验证时间字符串格式是否正确
    let regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

    return regex.test(dateTimeString);
};

export const isTwoValidDateTimeString = (dateTimeString:string) => {
    // 使用正则表达式验证时间字符串格式是否正确
    let regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2},\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

    return regex.test(dateTimeString);
};

export const capitalizeString = (str: string): string => {
    str = str.toLowerCase(); // 将字符串转换为小写
    return str.charAt(0).toUpperCase() + str.slice(1); // 将首字母大写并拼接剩余部分
};

export const isItLongitudeAndLatitude = (value:number) => {
    if (value && typeof value === 'number' && !isNaN(value)) {
        return true;
    }
    return false;
};

export type TaskLogProperty = {
    sn: string;
    taskid: string;
    etime: string;
    result: string;
    type: string;
    index: number;
}
import { LogListRow } from 'src/api/AmiFunction/taskMgnt/type';
import { store } from 'src/store';

export const computeLog = (row:TaskLogProperty, id:string, taskLogMap:Map<string, LogListRow[]>):Map<string, LogListRow[]> => {
    let logList:LogListRow[] = [];

    if (taskLogMap.has(id)) { // 是否存在该条抄读的日志
        logList = taskLogMap.get(id) as LogListRow[];
        let isExistlog = false;

        logList.forEach((v) => { // 如果时间，任务id，结果一样视为重复日志
            if (v.createTime === row.etime && v.log === row.result &&
                v.taskId === row.taskid
            ) {
                isExistlog = true;
            } else {
                isExistlog = false;
            }
        });
        console.info('taskLogMap-----', taskLogMap);
        console.info('isExistlog-----', isExistlog);
        if (!isExistlog) { // 如果存在重复日志，不添加
            logList.push({
                sn: row.taskid,
                taskId: row.taskid,
                createTime: row.etime,
                log: row.result,
                type: row.type,
                index: logList.length + 1,
            });
            taskLogMap.set(id, logList);
        }
    } else { // 不存在新增一项，并添加数据
        logList.push({
            sn: row.taskid,
            taskId: row.taskid,
            createTime: row.etime,
            log: row.result,
            type: row.type,
            index: logList.length + 1,
        });
        taskLogMap.set(id, logList);
    }
    return taskLogMap;
};

const FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const getServerTime = () => {
    const serverTime = store.getState()?.defaultTime.serverTime;

    if (serverTime) {
        return moment(serverTime, FORMAT);
    } else {
        return moment(new Date(), FORMAT);
    }
};

export const formatAmount = (input: number | string | null | undefined): string => {
    if (typeof input === 'string') {
        input = input.replace(/^0+/, '');

        if (/^\d+$/.test(input)) {
            input = parseInt(input, 10);
            return input.toLocaleString('en-US');
        } else {
            return '0';
        }
    } else if (typeof input === 'number') {
        return input.toLocaleString('en-US');
    } else {
        return '0';
    }
};

export const isInfinite = (num:number):boolean => {
    // 使用lodash的_.isFinite来检查是否为有限数
    if (!isFinite(num)) {
        // 如果不是有限数，则检查是否为正无穷大或负无穷大
        return num === Number.POSITIVE_INFINITY || num === Number.NEGATIVE_INFINITY;
    }
    // 如果是有限数，则返回false
    return false;
};

export const formatRatio = (val: number): number => {
    if (isNaN(val) || isInfinite(val)) {
        val = 0;
    }
    if (val > 100) {
        val = 100;
    }
    return val;
};

export const compareDates = (dateStr1: string, dateStr2: string): boolean => {
    // 创建Date对象
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    // 检查两个日期是否有效（即，它们是否成功解析）
    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
        return false;
    }

    // 比较两个日期
    return date1 > date2;
};

// 加密
export const rsaEncrypt = (txt:string, afterPublicKey:string) => {
    const encryptor = new JSEncrypt();

    encryptor.setPublicKey(afterPublicKey); // 设置公钥
    return encryptor.encrypt(txt); // 对数据进行加密
};

// 解密
export const rsaDecrypt = (txt:string, frontPrivateKey:string) => {
    const encryptor = new JSEncrypt();

    encryptor.setPrivateKey(frontPrivateKey); // 设置私钥
    return encryptor.decrypt(txt); // 对数据进行解密
};

export const canDivide = (a:number, b:number):boolean => {
    // 确保b不为0，因为除以0会导致错误
    if (b === 0) {
        return false; // 或者你可以抛出一个错误
    }

    // 使用模运算符检查余数是否为0
    return a % b === 0;
};

export const checkFileError = (errStr: string):boolean => {
    const errorStrs = [ 'Loading', 'chunk', 'failed' ];
    let flag = true;

    for (const str of errorStrs) {
        if (!errStr.includes(str)) {
            flag = false;
        }
    }
    return flag;
};

export const removeUnitAndConvertToNumber = (str: string): number => {
    if (typeof str !== 'string') {
        return 0;
    }
    // 使用正则表达式匹配数字部分，并忽略后面的单位
    const match = str?.match(/^\s*(\d+(\.\d+)?)\s*([A-Za-z]+)?\s*$/);

    if (!match || !match[1]) {
        // 如果没有找到数字或单位不符合预期，可以抛出一个错误或返回特定的值
        return 0;
    }

    // 转换匹配到的数字部分为浮点数
    const number = parseFloat(match[1]);

    // 如果转换结果为NaN，则表明原始字符串中的数字部分不合法
    if (isNaN(number)) {
        return 0;
    }

    return number;
};

import { DevicePhaseRes } from 'src/pages/homePage/deviceSnapshot/devicePhase';

// eslint-disable-next-line complexity
export const computePhasePower = (obj: any):DevicePhaseRes => {
    let powerANumSign = '';
    let powerBNumSign = '';
    let powerCNumSign = '';
    let rPowerANumSign = '';
    let rPowerBNumSign = '';
    let rPowerCNumSign = '';

    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_35']) > 0) {
        powerANumSign = '-';
    }
    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_36']) > 0) {
        powerBNumSign = '-';
    }
    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_37']) > 0) {
        powerCNumSign = '-';
    }
    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_43']) > 0) {
        rPowerANumSign = '-';
    }
    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_44']) > 0) {
        rPowerBNumSign = '-';
    }
    if (removeUnitAndConvertToNumber(obj['CAP_OBJ_DATA_45']) > 0) {
        rPowerCNumSign = '-';
    }
    return {
        iaValue: obj?.['CAP_OBJ_DATA_2'] || '0',
        ibValue: obj?.['CAP_OBJ_DATA_4'] || '0',
        icValue: obj?.['CAP_OBJ_DATA_6'] || '0',
        vaValue: obj?.['CAP_OBJ_DATA_3'] || '0',
        vbValue: obj?.['CAP_OBJ_DATA_5'] || '0',
        vcValue: obj?.['CAP_OBJ_DATA_7'] || '0',
        iaAngle: obj?.['CAP_OBJ_DATA_48'] || '0',
        ibAngle: obj?.['CAP_OBJ_DATA_51'] || '0',
        icAngle: obj?.['CAP_OBJ_DATA_52'] || '0',
        vaAngle: '0',
        vbAngle: obj?.['CAP_OBJ_DATA_19'] || '0',
        vcAngle: obj?.['CAP_OBJ_DATA_20'] || '0',
        aApValue: powerANumSign + (obj?.['CAP_OBJ_DATA_9'] || '0'),
        bApValue: powerBNumSign + (obj?.['CAP_OBJ_DATA_10'] || '0'),
        cApValue: powerCNumSign + (obj?.['CAP_OBJ_DATA_11'] || '0'),
        dApValue: obj?.['CAP_OBJ_DATA_8'] || '0',
        aRAPValue: rPowerANumSign + (obj?.['CAP_OBJ_DATA_13'] || '0'),
        bRAPValue: rPowerBNumSign + (obj?.['CAP_OBJ_DATA_14'] || '0'),
        cRAPValue: rPowerCNumSign + (obj?.['CAP_OBJ_DATA_15'] || '0'),
        dRAPValue: obj?.['CAP_OBJ_DATA_12'] || '0',
        aFpValue: obj?.['CAP_OBJ_DATA_16'] || '0',
        bFpValue: obj?.['CAP_OBJ_DATA_17'] || '0',
        cFpValue: obj?.['CAP_OBJ_DATA_18'] || '0',
    };
};

export const findCommonDigits = (num1:number, num2:number):number[] => {
    // 将数字转换为字符串并拆分为字符数组
    const digits1 = String(num1).split('');
    const digits2 = String(num2).split('');

    // 使用 Map 统计每个数字的出现次数
    const countMap: Record<string, number> = {};

    // 统计第一个数字的数字出现次数
    digits1.forEach((digit) => {
        countMap[digit] = (countMap[digit] || 0) + 1;
    });

    // 找出相同的数字
    const commonDigits:number[] = [];

    // 遍历第二个数字的数字，检查是否在第一个数字中存在
    digits2.forEach((digit) => {
        if (countMap[digit] > 0) {
            commonDigits.push(Number(digit));
            countMap[digit]--; // 减少计数，处理重复数字
        }
    });

    return commonDigits;
};

export const replacePos = (strObj:string, pos:number, replacetext:string):string => {
    let str = strObj.substr(0, pos - 1) + replacetext + strObj.substring(pos, strObj.length);

    return str;
};

/**
 * 计算列表分页删除后当前页数
 * @param  {number} page 当前页数值
 * @param {number} pageSize 每页数值
 * @param {number} total 列表总数
 * @param {number} selectLength 选择数量
 * @returns {number} 返回分页数值
 */
export const computeCurrentPage = (page: number, pageSize: number, total: number, selectLength: number): number => {
    let num = page;

    if ((page - 1) * pageSize + selectLength === total && page > 1) {
        num -= 1;
    }
    return num;
};
